import {useRecoilState} from "recoil";
import {mainMenuState, spaceState} from "@services/stores/storeState";

const SystemViewModel = () => {
    const [spaceInfoState, setSpaceInfoState] = useRecoilState(spaceState);
    const [mainMenuOpenState, setMainMenuOpenState] = useRecoilState(mainMenuState);

    // 현재 액티브되어 있는 메뉴 설정
    const setActiveRoute = (menuId: string) => {
        setSpaceInfoState({...spaceInfoState, activeRoute: menuId});
    }

    // 모바일 메뉴를 오픈한다.
    const setMenuToggle = () => {
        setMainMenuOpenState(!mainMenuOpenState);
    }

    return {
        spaceInfoState,
        setActiveRoute,
        setMenuToggle
    }
}

export default SystemViewModel;